import { type StreamForDashboard, type StreamIguanaObject } from 'Lessons';
import { type CurrentUser, type CurrentUserIguanaObject } from 'Users';
import { buildAuthHeaders } from 'BackRoyalApi/queryShared';
import { unclaimedAdminExamVerificationRecordForStream } from './examVerificationRecordForStream';
import { getOrGenerateExamVerificationSessionId } from './getOrGenerateExamVerificationSessionId';

const baseApiUrl = `${window.ENDPOINT_ROOT}/api/exam_verifications/claim/`;

// Accepts the Iguana or the vanilla user and stream.
export async function claimExamVerification(
    user: CurrentUser | CurrentUserIguanaObject,
    stream: StreamForDashboard | StreamIguanaObject,
) {
    const requestInit = {
        method: 'POST',
        headers: buildAuthHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({
            exam_verification_id: unclaimedAdminExamVerificationRecordForStream(user, stream)?.id,
            exam_verification_session_id: getOrGenerateExamVerificationSessionId(stream),
        }),
    };
    return fetch(`${baseApiUrl}`, requestInit);
}
